










































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import { ConsultaColetiva } from '../../../../back/src/entity/ConsultaColetiva';

import Requester from '../../requester';

export default Vue.extend({
  name: 'ConsultasColetivasDataTable',
  props: {
    tipoConsultasColetivas: {
      default: '',
    },
    dataBusca: {
      default: '',
    },
  },
  components: {
  },
  data() {
    return {
      listaConsultasColetivas: [],
      totalRegistros: 0,
      loadingTable: false,
      options: {
        itemsPerPage: 30,
      },
      headers: [
        {
          value: 'id',
          text: 'Id ',
          sortable: true,
          align: 'center',
        },
        {
          value: 'datetime_agendamento',
          text: 'Início agendado ',
          sortable: true,
          align: 'center',
        },
        {
          value: 'datetime_agendamento_fim',
          text: 'Fim agendado ',
          sortable: true,
          align: 'center',
        },
        {
          value: 'num_participantes',
          text: 'Num. participantes',
          sortable: false,
          align: 'center',
        },
        {
          value: 'actions',
          text: 'Ações ',
          sortable: false,
          align: 'right',
        },
      ],
    };
  },
  mounted() {
  },
  computed: {
    numPaginas() {
      if (this.totalRegistros === 0) {
        return 1;
      }
      return Math.ceil(this.totalRegistros / this.options.itemsPerPage);
    },
    consultasColetivasItens() {
      return _.map(this.listaConsultasColetivas, (consulta) => {
        const itemConsultaColetiva = {
          id: consulta.id,
          datetime_agendamento: consulta.datetime_agendamento,
          datetime_agendamento_fim: consulta.datetime_agendamento_fim,
          hora: moment(consulta.datetime_agendamento).format('HH:mm'),
          num_participantes: consulta.consultas.length,
        };
        return itemConsultaColetiva;
      });
    },
  },
  methods: {
    dataDisplay(datetimeAgendamento) {
      return moment(datetimeAgendamento).format('DD/MM/YYYY HH:mm');
    },
    async carregaNovaPagina() {
      this.loadingTable = true;
      const queryObj: any = {
        tipo: this.tipoConsultasColetivas,
        pagina: this.options.page,
        itens_por_pagina: this.options.itemsPerPage,
      };
      if (this.options.sortBy.length > 0) {
        [queryObj.sortBy] = this.options.sortBy;
        [queryObj.sortDesc] = this.options.sortDesc;
      }
      if (this.dataBusca.length > 0) {
        queryObj.data = this.dataBusca;
      }
      try {
        const response = await Requester.consultaColetiva.buscaConsultasColetivas(queryObj);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.listaConsultasColetivas = response.data.registros;
          this.totalRegistros = response.data.total_registros;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loadingTable = false;
      }
    },
    mostrarDadosConsultaColetiva(consultaColetivaId: number) {
      this.$emit('mostrarDadosConsultaColetiva',
        _.find(this.listaConsultasColetivas, consulta => consulta.id === consultaColetivaId));
    },
  },
  watch: {
    options: {
      handler() {
        this.carregaNovaPagina();
      },
      deep: true,
    },
  },
});
